export default function FooterSection() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="w-full bg-slate-800 text-white pt-16 pb-0 rounded-t-[40px]">
      <div className="max-w-6xl mx-auto px-6 md:px-10">

        {/* Main Footer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-12 border-b border-white/10">

          {/* Brand Column */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/7b32f896-56e9-40d0-9374-4218a73d8bc8.png"
                alt="Lake Claiborne Rentals Logo"
                className="h-14 w-auto object-contain"
              />
              <span className="text-white font-serif text-xl font-semibold leading-tight">
                Lake Claiborne<br />
                <span className="text-teal-400 font-normal italic text-lg">Rentals</span>
              </span>
            </div>
            <p className="text-white/55 text-sm leading-relaxed mb-6">
              The premier directory of short-term rental properties on Lake Claiborne — cabins, cottages, and waterfront homes, all in one place.
            </p>
            <div className="flex items-center gap-3">
              {[
                { icon: 'ri-facebook-fill', label: 'Facebook' },
                { icon: 'ri-instagram-line', label: 'Instagram' },
                { icon: 'ri-mail-line', label: 'Email' },
              ].map(({ icon, label }) => (
                <a
                  key={label}
                  href="#"
                  aria-label={label}
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:text-white hover:border-white/50 transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* Explore Column */}
          <div>
            <h4 className="text-white text-xs font-bold tracking-widest uppercase mb-5">Explore</h4>
            <ul className="space-y-3">
              {[
                { label: 'About Lake Claiborne', id: 'about' },
                { label: 'Lake Statistics', id: 'stats' },
                { label: 'Get Notified', id: 'signup' },
              ].map(({ label, id }) => (
                <li key={label}>
                  <button
                    onClick={() => scrollTo(id)}
                    className="whitespace-nowrap text-white/55 hover:text-teal-400 text-sm transition-colors cursor-pointer"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-white text-xs font-bold tracking-widest uppercase mb-5">Get in Touch</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-white/55 text-sm">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-2-line text-teal-400" />
                </div>
                <span>Lake Claiborne<br />Homer, Louisiana 71040</span>
              </li>
              <li className="flex items-center gap-3 text-white/55 text-sm">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-teal-400" />
                </div>
                <a href="mailto:info@lakeclaibornerentals.com" className="hover:text-teal-400 transition-colors">
                  info@lakeclaibornerentals.com
                </a>
              </li>
              <li className="mt-2">
                <span className="inline-block bg-teal-500/20 text-teal-400 text-xs font-semibold tracking-wide border border-teal-500/30 rounded-full px-3 py-1">
                  Launching 2025
                </span>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 py-6 text-white/35 text-xs">
          <span>&copy; {new Date().getFullYear()} Lake Claiborne Rentals. All rights reserved.</span>
          <div className="flex items-center gap-4">
            <a href="#" className="hover:text-white/60 transition-colors">Privacy Policy</a>
            <span>|</span>
            <a href="#" className="hover:text-white/60 transition-colors">Terms of Service</a>
          </div>
        </div>

      </div>
    </footer>
  );
}
